exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":0,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2cc34029","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./layouts/empty.vue
// module id = VUbe
// module chunks = 202